$ = require 'jquery'
Backbone = require 'app/scripts/lib/backbone'
Hearsay = require 'hearsay'
SchedulingMixin = require 'app/scripts/lib/scheduling-mixin'
_ = require 'underscore'
l = require 'app/scripts/lib/localize'
{ logError } = require 'app/scripts/debug/log-error'
Promise = require 'bluebird'
SubviewRemover = require 'app/scripts/views/internal/subview-remover'

{ defaultRouter } = require 'app/common/router'

VIGOR =
  NONE: 0
  SOME: 1
  LOTS: 2

class View extends Backbone.View
  constructor: (options) ->
    @_subviews = {}
    @modelCache = options?.modelCache

    # Ideally we'd want updateSubscribers to be called from
    # a route change, but the time between route change and rendering
    # is too big right now. The next best option is a componentDidMount,
    # but that would need to be hooked into the main Views, which are
    # Backbone views right now. Until Classic migrates to a react
    # tailored routing solution, we are hooking this to the base View
    # constructor/initializer used by Classic Backbone views.
    defaultRouter.updateSubscribers()

    super

  _rendered: false
  @VIGOR: VIGOR
  vigor: VIGOR.LOTS

  render: (args...) ->
    # Backbone.View defaults to a no-op render; if there's no renderOnce,
    # that's probably what we intended.
    if !@renderOnce?
      return @

    if @_rendered
      switch @vigor
        when VIGOR.NONE
          return @
        when VIGOR.SOME
          logError Error("rendered more than once: #{ @constructor.name }")
          return @
        else
          throw Error "You cannot render me more than once!"
    @_rendered = true

    @renderOnce(args...)

    @

  renderIfNecessary: ->
    if !@renderOnce || !@_rendered
      @render()
    @

  getViewTitle: ->
    if !@viewTitleKey?
      return ""
    key = _.result(@, 'viewTitleKey')
    args = _.result(@, 'viewTitleArguments') ? {}
    l(['view title', key], args)

  subview: (Type, model, opts = {}, key = "#{ Type::uniqueId() }_#{ model.cid }") ->
    if key not of @_subviews
      @_subviews[key] = new Type(_.extend({ model, @modelCache }, opts))
    return @_subviews[key]

  existingSubview: (Type, model, key = "#{ Type::uniqueId() }_#{ model.cid }") ->
    if key not of @_subviews
      throw new Error("existingSubview called before subview was created")
    return @_subviews[key]

  existingSubviewOrUndefined: (Type, model, key = "#{ Type::uniqueId() }_#{ model.cid }") ->
    return @_subviews[key]

  collectionSubview: (Type, collection, opts = {}, key = Type::uniqueId()) ->
    subview = (@_subviews[key] ?= new Type(_.extend({ collection, @modelCache }, opts)))
    # If a different el has been provided, switch the subview to it
    if opts.el? && subview.el != opts.el
      subview.setElement(opts.el)
    return subview

  subviewsOfType: (Type) ->
    subview for own key, subview of @_subviews when subview instanceof Type

  deleteSubview: (view, key = "#{ view.constructor::uniqueId() }_#{ view.model.cid }") ->
    if view != @_subviews[key]
      throw new Error "incorrect key for subview in deleteSubview"
    view.remove()
    delete @_subviews[key]

  removeSubviews: ->
    subviews = _.values(@_subviews)
    @_subviews = {}
    SubviewRemover.enqueue(subviews)
    return

  deleteSubviewsOfType: (Type) ->
    for subview in @subviewsOfType(Type)
      @deleteSubview(subview)
    return

  remove: ->
    @unsubscribe()
    @stopUsing()
    @removeSubviews()

    @cancelScheduled()

    super

  frameDebounce: (fn, context = this) ->
    invoked = false
    return ->
      if invoked
        return
      invoked = true
      @requestAnimationFrame ->
        invoked = false
        fn.call(context)
        return
      return

  makeDebouncedMethods: (methodNames...) ->
    for methodName in methodNames
      @[methodName + 'Debounced'] = @frameDebounce(@[methodName])
    return

  delegateEvents: (args...) ->
    super(args...)
    for key, view of @_subviews
      view.delegateEvents()
    return

  undelegateEvents: ->
    super
    for key, view of @_subviews
      view.undelegateEvents()
    return

  appendSubview: (subview, $el) ->
    @appendSubviews([subview], $el)

  appendSubviews: (subviews, $el = @$el) ->
    frag = document.createDocumentFragment()
    for subview in subviews
      subview.delegateEvents()
      frag.appendChild(subview.render().el)
    $el.append(frag)

  ensureSubview: (subview, $el) ->
    @ensureSubviews([subview], $el)

  ensureSubviews: (subviews, $el = @$el) ->
    elContainer = $el[0]
    elContainerNodes = _.clone elContainer.childNodes

    # Remove elements that aren't supposed to be there anymore
    for el, index in elContainerNodes when !_.find(subviews, (s) -> s.el == el)
      found = false
      for key, view of @_subviews when view.el == el && !found
        @deleteSubview(view, key)
        found = true

      if !found
        throw new Error("Could not find view associated with element to remove")

    # Render subviews that are new
    for subview in subviews when !_.find(elContainerNodes, (el) -> subview.el == el)
      subview.delegateEvents()
      subview.render()

    for subview, index in subviews
      if subview.el == elContainer.childNodes[index]
        continue

      if index == 0
        $(elContainer).prepend(subview.el)
      else
        $(subviews[index - 1].el).after(subview.el)

    return

  uniqueId: ->
    if !@hasOwnProperty('_uniqueId')
      @_uniqueId = _.uniqueId('view')

    @_uniqueId

_.extend View.prototype, SchedulingMixin, Hearsay.mixin

module.exports = View
